import React from 'react';
import { View, Text, ScrollView, ActivityIndicator, Image, TextInput, CheckBox, FlatList } from 'react-native';
import { Button } from 'react-native-elements';
import screen from '../screen';
import Icon from 'react-native-vector-icons/FontAwesome';
import Lib from '../Lib';
import _ from 'lodash';
import moment from 'moment';
import Modal from 'modal-enhanced-react-native-web';
import log from 'loglevel';
import evmLib from '../evmLib';
import daoLib from '../daoLib';

const vp = screen.vp;
const vps = screen.vps;
const spc2 = <View style={{ width: vps(2), height: vps(2) }} />;
const spc1 = <View style={{ width: vps(1), height: vps(1) }} />;

function to4dec(amount) {
  return (Math.round(Number(amount) * 10000) / 10000);
}

class Panels extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  async componentDidMount() {
    // this.interval = setInterval(() => {
    //   this.setState({ ts: moment().unix() });
    // }, 1000);
    await this.refreshData();
  }

  componentWillUnmount() {
    // clearInterval(this.interval);
  }

  async refreshData() {
  }

  renderPanel(title, desc, btnTitle, cb, disable, iconName) {
    if (!iconName) iconName = 'question';
    return (
      <View style={{ flex: 1, borderWidth: 1, borderColor: 'gainsboro', padding: vp * 2, backgroundColor: 'white' }}>
        <Text style={{ textAlign: 'center', fontWeight: 'bold' }}>{title.toUpperCase()}</Text>
        <View style={{ flex: 1, alignItems: 'center' }}>
          <Text> </Text>
          <Icon name={iconName} size={32} color="black" />
          <Text> </Text>
          <View style={{ flex: 1 }}>
            <Text style={{ textAlign: 'center' }}>
              {desc}
            </Text>
          </View>
          <Text> </Text>
        </View>
        <Button disabled={disable} title={btnTitle} onPress={() => cb()} />
      </View>
    );
  }


  renderPanelJoin() {
    const pd = this.props.panelsData;
    const selectedNFT = pd.selectedNFT;
    const userETH = pd.userETH;
    const nftPendingWithdraw = pd.nftPendingWithdraw;
    let desc = 'Stake 1000 CFX and mint NFT to join.';
    let disable = true;

    const txt1 = 'Stake 1000 CFX and mint NFT to join.';
    if (selectedNFT && selectedNFT > 0) {
      desc = (
        <View>
          <Text style={{ textAlign: 'center' }}>{txt1}</Text>
          <Text style={{ textAlign: 'center', color: 'green' }}>[already own NFT]</Text>
        </View>
      );
    } else if (nftPendingWithdraw) {
      desc = (
        <View>
          <Text style={{ textAlign: 'center' }}>{txt1}</Text>
          <Text style={{ textAlign: 'center', color: 'red' }}>[unstake not finished]</Text>
        </View>
      );
    } else {
      if (Number(userETH) > 1000) {
        disable = false;
      } else {
        desc = (
          <View>
            <Text style={{ textAlign: 'center' }}>{txt1}</Text>
            <Text style={{ textAlign: 'center', color: 'red' }}>[not enough CFX]</Text>
          </View>
        );
      }
    }

    return this.renderPanel('Join', desc, 'Mint NFT', () => this.props.onClickJoin(), disable, 'sign-in');
  }

  renderPanelLeave() {
    const pd = this.props.panelsData;
    const txt1 = 'Burn NFT and unstake 1000 CFX to leave.';
    const ts = pd.ts;
    const selectedNFT = pd.selectedNFT;
    const nftPendingWithdraw = pd.nftPendingWithdraw;
    const nftPendingWithdrawDeadline = pd.nftPendingWithdrawDeadline;
    const nftMayWithdraw = pd.nftMayWithdraw;
    const nftDataList = pd.nftDataList;

    let desc = (
      <View>
        <Text style={{ textAlign: 'center' }}>{txt1}</Text>
        <Text style={{ textAlign: 'center', color: 'red' }}>[cult access]</Text>
      </View >
    );

    if (nftPendingWithdraw) {
      if (nftMayWithdraw) {
        const disable = false;
        desc = (
          <View>
            <Text style={{ textAlign: 'center' }}>{txt1}</Text>
            <Text style={{ textAlign: 'center', color: 'green' }}>[1000 CFX can be unstaked]</Text>
          </View >
        );
        return this.renderPanel('Leave', desc, 'Unstake CFX', () => this.props.onClickWithdraw(), disable, 'sign-out');
      } else {
        const disable = true;
        const deadlineStr = moment.unix(nftPendingWithdrawDeadline).format('DD MMM HH:mm');
        desc = (
          <View>
            <Text style={{ textAlign: 'center' }}>{txt1}</Text>
            <Text style={{ textAlign: 'center', color: 'red' }}>[unstake enable on {deadlineStr}]</Text>
          </View >
        );
        return this.renderPanel('Leave', desc, 'Unstake CFX', () => { }, true, 'sign-out');
      }
    }

    if (selectedNFT && selectedNFT > 0) {
      desc = (
        <View>
          <Text style={{ textAlign: 'center' }}>{txt1}</Text>
        </View >
      );
    }

    let disable = true;
    if (selectedNFT && selectedNFT > 0) {
      const dataListByKey = _.keyBy(nftDataList, 'id');
      const selectedNFTData = dataListByKey[selectedNFT];
      const allowBurnTime = selectedNFTData.allowBurnTime;
      if (ts > allowBurnTime) {
        disable = false;
      } else {
        const msg = '[burn after ' + moment.unix(allowBurnTime).format('DD MMM HH:mm') + ']';
        desc = (
          <View>
            <Text style={{ textAlign: 'center' }}>{txt1}</Text>
            <Text style={{ textAlign: 'center', color: 'red' }}>{msg}</Text>
          </View >
        );
      }
    }


    return this.renderPanel('Leave', desc, 'Burn NFT', () => this.props.onClickLeave(), disable, 'sign-out');
  }

  renderPanelClaim() {
    const pd = this.props.panelsData;
    const rewardPerNFT = pd.rewardPerNFT;
    const nextUpdateTime = pd.nextUpdateTime;
    const selectedNFT = pd.selectedNFT;
    const nftDataList = pd.nftDataList;
    const nftSession = pd.nftSession;

    const txt1 = 'Receive ' + rewardPerNFT + ' XYZ every 24 hours.';
    let desc = (
      <View>
        <Text style={{ textAlign: 'center' }}>{txt1}</Text>
        <Text style={{ textAlign: 'center', color: 'red' }}>[cult access]</Text>
      </View >
    );

    let disable = true;
    if (selectedNFT && selectedNFT > 0) {
      const key = selectedNFT + '';
      const dataListByKey = _.keyBy(nftDataList, 'id');
      const selectedNFTData = dataListByKey[key];
      if (
        selectedNFTData.session < nftSession
        && Number(rewardPerNFT) > 0
      ) {
        desc = (
          <View>
            <Text style={{ textAlign: 'center' }}>{txt1}</Text>
            <Text style={{ textAlign: 'center', color: 'green' }}>[claim now]</Text>
          </View >
        );
        disable = false;
      } else {
        desc = (
          <View>
            <Text style={{ textAlign: 'center' }}>{txt1}</Text>
            <Text style={{ textAlign: 'center', color: 'red' }}>[claim after {moment.unix(nextUpdateTime).format('DD MMM HH:mm')}]</Text>
          </View >
        );
      }
    }
    return this.renderPanel('Claim', desc, 'Claim XYZ', () => this.props.onClickClaim(), disable, 'gift');
  }

  renderPanelBurn() {
    const pd = this.props.panelsData;
    const sellPrice = pd.sellPrice;
    const selectedNFT = pd.selectedNFT;
    let disable = true;

    const txt1 = 'Swap XYZ for USDT. 1 XYZ = ' + sellPrice + ' USDT.'
    let desc = (
      <View>
        <Text style={{ textAlign: 'center' }}>{txt1}</Text>
        <Text style={{ textAlign: 'center', color: 'red' }}>[cult access]</Text>
      </View >
    );

    if (selectedNFT && selectedNFT > 0) {
      desc = (
        <View>
          <Text style={{ textAlign: 'center' }}>{txt1}</Text>
        </View >
      );
      disable = false;
    }

    return this.renderPanel('Swap', desc, 'Swap XYZ', () => this.props.onClickSell(), disable, 'refresh');
  }

  renderPanelStake() {
    const pd = this.props.panelsData;
    const apr = pd && pd.apr > 0 ? Math.floor(pd.apr) : '';
    const ts1 = { textAlign: 'center', color: 'white', fontWeight: 'bold', fontSize: 24 };

    return (
      <View style={{ flex: 1 }}>
        <View style={{ backgroundColor: 'green', padding: vps(2) }}>
          <Text style={ts1}>STAKING</Text>
        </View>
        <View style={{ flex: 1, borderWidth: 1, borderColor: 'gainsboro', padding: vp * 2, backgroundColor: 'white' }}>
          <View style={{ flex: 1, alignItems: 'center' }}>
            <Text> </Text>
            <Icon name='flask' size={32} color="black" />
            <Text> </Text>
            <View style={{ flex: 1 }}>
              <Text style={{ textAlign: 'center' }}>
                <View style={{ justifyContent: 'center', alignItems: 'center', height: 60 }}>
                  <Text style={{ textAlign: 'center' }}>
                    LP Staking Vault.
                  </Text>
                  <Text style={{ textAlign: 'center' }}>
                    Stake Swappi XYZ-USDT LP token for <Text style={{ fontWeight: 'bold' }}>{apr}% APR.</Text>
                  </Text>
                </View >
              </Text>
            </View>
            <Text> </Text>
          </View>
          <Button disabled={false} title={'Stake LP'} onPress={() => this.props.onClickStake()} />
        </View>
      </View>
    );
  }

  renderPanelBonding() {
    const pd = this.props.panelsData;
    const bonus = pd?.bonus;
    const bonusSampleAmount = pd?.bonusSampleAmount;
    const ts1 = { textAlign: 'center', color: 'white', fontWeight: 'bold', fontSize: 24 };

    return (
      <View style={{ flex: 1 }}>
        <View style={{ backgroundColor: 'green', padding: vps(2) }}>
          <Text style={ts1}>BONDING</Text>
        </View>
        <View style={{ flex: 1, borderWidth: 1, borderColor: 'gainsboro', padding: vp * 2, backgroundColor: 'white' }}>
          <View style={{ flex: 1, alignItems: 'center' }}>
            <Text> </Text>
            <Icon name='lock' size={32} color="black" />
            <Text> </Text>
            <View style={{ flex: 1 }}>
              <Text style={{ textAlign: 'center' }}>
                <View style={{ justifyContent: 'center', alignItems: 'center', height: 60 }}>
                  <Text style={{ textAlign: 'center' }}>
                    Trade XYZ at discounted price.
                  </Text>
                  <Text style={{ textAlign: 'center' }}>
                    Get <Text style={{ fontWeight: 'bold' }}>+{bonus}% </Text> more XYZ than Swappi for {bonusSampleAmount} USDT.
                  </Text>
                </View >
              </Text>
            </View>
            <Text> </Text>
          </View>
          <Button disabled={false} title={'Trade'} onPress={() => this.props.onClickSwap()} />
        </View>
      </View>
    );
  }

  renderHowTo() {
    const title = 'Optimal Strategy for Bonding & Staking';
    return (
      <View style={{ alignItems: 'center', padding: vps(4) }}>
        <Text style={{ textAlign: 'center', fontWeight: 'bold' }}>{title.toUpperCase()}</Text>
        <Text> </Text>
        <View>
          <Text>1. Trade for USDT in Swappi.</Text>
          <Text>2. Use BONDING to swap half USDT for XYZ.</Text>
          <Text>3. Provide liquidity for XYZ-USDT in Swappi to get LP token.</Text>
          <Text>4. Use STAKING to stake XYZ-USDT LP token for yield.</Text>
          <Text>5. Claim XYZ yield and sell half for USDT in Swappi.</Text>
          <Text>6. Back to step 3 to reinvest for more yield.</Text>
        </View>
        <Text> </Text>
        <Text> </Text>
      </View>
    );
  }

  renderTitle() {
    const title = 'Dragon Cult XYZ';
    const msg = 'Low volatile - DAO controlled - treasury token, with high APR through bonding & staking mechanism.';
    return (
      <View style={{ paddingHorizontal: vps(2) }}>
        {spc2}
        <View style={{ borderWidth: 1, borderColor: 'gainsboro', padding: vps(2) }}>
          <Text style={{ textAlign: 'center', fontWeight: 'bold' }}>{title.toUpperCase()}</Text>
          <Text> </Text>
          <Text style={{ textAlign: 'center' }}>{msg}</Text>
        </View>
      </View>
    );
  }


  render() {
    const ts1 = { textAlign: 'center', color: 'white', fontWeight: 'bold', fontSize: 24 };
    return (
      <View style={{ flex: 1, backgroundColor: 'white', maxWidth: vps(100), borderWidth: 0 }}>
        {this.renderTitle()}
        <View style={{ flexDirection: 'row', padding: vps(2) }}>
          <View style={{ flex: 1 }}>
            {this.renderPanelStake()}
          </View>
          {spc2}
          <View style={{ flex: 1 }}>
            {this.renderPanelBonding()}
          </View>
        </View>
        {/* {this.renderHowTo()} */}
        <View style={{ height: vps(2), backgroundColor: 'gainsboro' }} />
        <View style={{ borderBottomWidth: 1, borderColor: 'gainsboro', padding: vps(2) }}>
          <Text style={{ textAlign: 'center', color: 'dimgray', fontWeight: 'bold' }}>DRAGON CULT NFT</Text>
        </View>
        <View style={{ flexDirection: 'row', padding: vps(2) }}>
          <View style={{ flex: 1 }}>{this.renderPanelJoin()}</View>
          {spc2}
          <View style={{ flex: 1 }}>{this.renderPanelLeave()}</View>
        </View>
        <View style={{ flexDirection: 'row', padding: vps(2) }}>
          <View style={{ flex: 1 }}>{this.renderPanelClaim()}</View>
          {spc2}
          <View style={{ flex: 1 }}>{this.renderPanelBurn()}</View>
        </View>
      </View>
    );
  }


}

export default Panels;
